import { render } from "./OpenGymLead.vue?vue&type=template&id=fbf541f8&scoped=true"
import script from "./OpenGymLead.vue?vue&type=script&lang=js"
export * from "./OpenGymLead.vue?vue&type=script&lang=js"

import "./OpenGymLead.vue?vue&type=style&index=0&id=fbf541f8&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbf541f8"]])

export default __exports__